import { ExpandMore } from '@mui/icons-material';
import { Chip, Collapse } from '@mui/material';

import { Typography } from '@mui/material';

import { Stack } from '@mui/material';
import { Incident } from '@silbo/core';
import { transition } from '@silbo/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FareIncidents({ incidents, isDone }: { incidents: Incident[]; isDone?: boolean }) {
  const { t } = useTranslation('patient-transport');

  const [incidentsOpen, setIncidentsOpen] = useState(false);

  if (incidents.length === 1) {
    return <FareIncident incident={incidents[0]} />;
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setIncidentsOpen(!incidentsOpen)}
        sx={{ cursor: 'pointer' }}
      >
        <Stack direction="row" spacing={2}>
          <Typography>{t('fareDetails.incidents')}</Typography>
          <Typography fontWeight={600}>{incidents.length}</Typography>
        </Stack>
        <ExpandMore sx={{ transform: incidentsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition }} />
      </Stack>
      <Collapse in={incidentsOpen} unmountOnExit>
        <Stack gap={4} marginTop={2}>
          {incidents.map((incident) => (
            <FareIncident key={incident.id} incident={incident} isDone={isDone} />
          ))}
        </Stack>
      </Collapse>
    </>
  );
}

const FareIncident = ({ incident, isDone }: { incident: Incident; isDone?: boolean }) => {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack gap={1}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography>{t('incident')} :</Typography>
        <Chip
          label={t(`fareIncidents.${incident.reason}` as unknown as TemplateStringsArray)}
          size="x-small"
          color={isDone ? 'default' : 'warning'}
          variant="lightRounded"
          sx={{ opacity: isDone ? 0.5 : undefined, filter: isDone ? 'grayscale(1)' : undefined }}
        />
        {incident.delayInMinutes !== undefined && incident.delayInMinutes > 0 && (
          <Chip
            label={`${incident.delayInMinutes} min`}
            size="x-small"
            color={isDone ? 'default' : 'warning'}
            variant="lightRounded"
            sx={{ opacity: isDone ? 0.5 : undefined, filter: isDone ? 'grayscale(1)' : undefined }}
          />
        )}
      </Stack>
      <Typography variant="body2">{incident.comment}</Typography>
    </Stack>
  );
};
